<div [@fadeIn]="true">
  <p-toast [baseZIndex]="10000"></p-toast>

  @if (isLoading) {
    <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
  } @else if(!errorOnLoad && !isLoading && !isLoadingAirlines) {
    <div class="d-flex justify-content-center scroll min-height">
      <div class="row col-10">
        <p-fieldset legend="{{ 'Administration.Cleanup.Title' | translate }}">
          <div class="row mt-1 mb-5">
            <div class="p-field offset-2" [ngClass]="{'col-3': !isLoadingStatusProcess, 'mt-4': isLoadingStatusProcess, 'col-1': isLoadingStatusProcess }">
              <p-progressBar *ngIf="isLoadingStatusProcess" mode="indeterminate" ></p-progressBar>
              <span *ngIf="!isLoadingStatusProcess" class="d-flex p-field-inputSwitch pt-3">
                <label class="d-flex mt-1"
                       pTooltip="{{ cleanupFormComponent?.genericCleanupForm?.form.invalid ? ('Administration.Cleanup.Information.Enabled When Filled Form' | translate) : '' }}"
                       tooltipPosition="right"
                       translate>
                  <p-inputSwitch
                        (onChange)="changeStatusProcess()"
                       #processEnabled
                       name="processEnabled"
                       class="mr-2 mt-1"
                       [disabled]="cleanupFormComponent?.genericCleanupForm?.form.invalid"
                       [(ngModel)]="cleanupInfo?.globalCleanupConfigurationInfo.isProcessEnabled">
                  </p-inputSwitch>
                  <span class="mt-1"> {{ ( cleanupInfo?.globalCleanupConfigurationInfo.isProcessEnabled ? 'Administration.Cleanup.Process Enabled' : 'Administration.Cleanup.Process Disabled' ) | translate }} </span>
                </label>
              </span>
            </div>

            <div class="p-field p-field-load col-3" [ngClass]="{ 'offset-2': !isLoadingStatusProcess, 'offset-4': isLoadingStatusProcess }">
              <div class="p-inputgroup">
                <span class="mr-3">
                  <i class="pi pi-calendar"></i>
                </span>
                <p-floatlabel>
                  <input pInputText
                         name="lastExecution"
                         type="text"
                         [readonly]="true"
                         [ngModel]="cleanupInfo?.globalCleanupConfigurationInfo.lastExecutionDate ? (cleanupInfo.globalCleanupConfigurationInfo.lastExecutionDate | date: 'dd/MM/yyyy h:mm:ss') : 'Administration.Cleanup.No Execution Date' | translate"
                  />
                  <label class="ml-3" translate> Administration.Cleanup.Last Execution </label>
                </p-floatlabel>
              </div>
            </div>
          </div>

          <app-administration-cleanup-form
            [genericCleanupView]="cleanupInfo?.globalCleanupConfigurationInfo"
          ></app-administration-cleanup-form>

          <div class="mb-4"></div>

          <app-administration-cleanup-list
            [customerCleanupConfigurations]="cleanupInfo?.customerCleanupConfigurations"
            [editing]="editing"
            (isLoadingMethod)="updateIsLoading($event)"
            (isEditingMethod)="isEditing($event)"
            (showToastMethod)="showToast($event)"
            (updateListModificationMethod)="updateListModification($event)"
          ></app-administration-cleanup-list>
          <div class="mt-5 mb-4 mr-8 d-flex justify-content-end">
            <p-button severity="primary" id="saveCleanupProcess" type="button" class="float-right mr-3" icon="pi pi-save" label="{{ 'Common.Save' | translate }}" (click)="saveCleanupProcess()"
                    [disabled]="( cleanupFormComponent?.genericCleanupForm?.form.invalid || editing || cleanupFormComponent?.genericCleanupForm?.form.pristine && checkChangesCustomerList() )">
            </p-button>
          </div>
        </p-fieldset>
      </div>
    </div>
  }
</div>
